/**
 * Extracts authentication parameters from URL hash or search params
 * @returns {Object} Object containing code, idToken, accessToken, and error
 */
export const extractParamsFromUrl = () => {
  const paramString = window.location.hash
    ? window.location.hash.substring(1)
    : window.location.search.substring(1);

  const params = new URLSearchParams(paramString);

  return {
    code: params.get("code"),
    idToken: params.get("id_token"),
    error: params.get("error"),
  };
};

/**
 * Cleans URL by removing query parameters and hash
 */
export const cleanUrl = () => {
  window.history.replaceState({}, document.title, window.location.pathname);
};
